;(function () {

"use strict";

var EntryView = require('./entry');

var TextAreaView = EntryView.extend({
  initialize: function (opts) {
    EntryView.prototype.initialize.call(this, opts);
    this.guid = App.guid();
    this.$el.prop('id', this.guid);

    tinyMCE.init({
      selector: '#'+this.guid,
      // plugins: ['link autolink anchor paste placeholder image code'],
      // menubar: false,
      // statusbar: false,
      // toolbar: "undo redo | bold italic | link image | code",
      height: 300,
      convert_urls: false,
      relative_urls: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table contextmenu paste code',
      ],
      browser_spellcheck: true,
      toolbar: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image | code | fullscreen removeformat | upload spellchecker',
      content_css: [
        '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
        '//cdnjs.cloudflare.com/ajax/libs/prism/0.0.1/prism.css',
        '//www.tinymce.com/css/codepen.min.css'
      ],
      extended_valid_elements: "img[loading|longdesc|usemap|src|border|alt=|title|hspace|vspace|width|height|align],details,summary,svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]",
      custom_elements: "details,summary",
      non_empty_elements: "td,th,iframe,video,audio,object,script,pre,code,area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed,source,wbr,track"
      // Now we add tags related to SVGs that it doesn't normally know about:
      + "svg,defs,pattern,desc,metadata,g,mask,path,line,marker,rect,circle,ellipse,polygon,polyline,linearGradient,radialGradient,stop,image,view,text,textPath,title,tspan,glyph,symbol,switch,use",
      content_style: '* { color: #000000 !important; }',
      setup: function (editor) {
        editor.addButton('upload', {
          type: 'menubutton',
          text: 'Upload',
          icon: false,
          menu: [{
            text: 'Upload Image',
            onclick: function () {
              console.log('uploading image');
              $('<input type="file" />').trigger('click').on('change', function () {

                var files = this.files;
                var formData = new FormData();

                // Loop through each of the selected files.
                for (var i = 0; i < files.length; i++) {
                  var file = files[i];

                  // Add the file to the request.
                  formData.append('files_'+i, file, file.name);
                }

                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/detail/upload', true);
                xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);

                var self = this;

                ShopifyApp.Bar.loadingOn();
                ShopifyApp.flashNotice('Upload Started');

                xhr.onload = function () {
                  if (xhr.status === 200) {
                    var json = JSON.parse(xhr.responseText);
                    if (json.err) {
                      ShopifyApp.Modal.alert({
                        title: 'An Upload Error Occured',
                        message: 'Sorry, Something went wrong. Please try this action again with smaller files or contact jason@thebestagency.com for more help.'
                      });
                    } else {
                      ShopifyApp.flashNotice('Upload Completed');
                      var src = json.savedFiles['files_0'];
                      editor.insertContent('<img src="'+src+'" />');
                    }
                    ShopifyApp.Bar.loadingOff();
                  } else {
                    alert('An error occurred!');
                    ShopifyApp.Bar.loadingOff();
                  }
                };
                xhr.send(formData);
              });
            }
          },
          {
            text: 'Upload File',
            onclick: function () {
              console.log('uploading image');
              $('<input type="file" />').trigger('click').on('change', function () {

                var files = this.files;
                var formData = new FormData();

                // Loop through each of the selected files.
                for (var i = 0; i < files.length; i++) {
                  var file = files[i];

                  // Add the file to the request.
                  formData.append('files_'+i, file, file.name);
                }

                var xhr = new XMLHttpRequest();
                xhr.open('POST', '/detail/upload', true);
                xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);

                var self = this;

                ShopifyApp.Bar.loadingOn();
                ShopifyApp.flashNotice('Upload Started');

                xhr.onload = function () {
                  if (xhr.status === 200) {
                    var json = JSON.parse(xhr.responseText);
                    if (json.err) {
                      ShopifyApp.Modal.alert({
                        title: 'An Upload Error Occured',
                        message: 'Sorry, Something went wrong. Please try this action again with smaller files or contact jason@thebestagency.com for more help.'
                      });
                    } else {
                      ShopifyApp.flashNotice('Upload Completed');
                      var src = json.savedFiles['files_0'];
                      editor.insertContent(src);
                    }
                    ShopifyApp.Bar.loadingOff();
                  } else {
                    alert('An error occurred!');
                    ShopifyApp.Bar.loadingOff();
                  }
                };
                xhr.send(formData);
              });
            }
          }]
        });
      }
    });
  },
  val: function () {
    var id = this.$el.prev().find('iframe').contents().find('body').data('id');
    var val = tinyMCE.get(id).getContent();

    if (val) {
      val = val.replace(/(\r\n\t|\n|\r\t)/gm,"");
    }

    // var str = val.replace(/<p>&nbsp;<\/p>/g, ' ');
    // var $val = $('<div>').html(str);
    // $val.find('*:empty').remove();

    return val;
    // return $val.html();
  },
  save: function () {
    /* Triggers save so the textarea has a value */
    tinyMCE.triggerSave();    
  }
});

module.exports = TextAreaView;

}());